import { useMemo, useReducer, useState, useEffect } from "react";
import { InputGroup, FormControl, Form, Modal, Button, Alert, Row, Container, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { GetHeadersOpts } from '../../App';
import PagerTable from '../../common/tables/PagerTable'
import Confirm from '../../common/widgets/Confirm'
import Select from 'react-select';



interface ListEditorProps {
    onListSaved: (close?: boolean) => void,
    getHeaders: (opts?: GetHeadersOpts) => Headers
    list: any
}

interface callDisposition {
    callDispositionId: number;
    callDispositionType: number;
    clientId: number;
    createDate: Date;
    deleted: boolean;
    disposition: string;
    extDispCode: string;
    isNew: boolean;
    lastModified: Date;
    modifiedBy: string;
    priorityPosition: number;
    lastModifiedString: string;
    editbtn: any; // Function returning JSX
}

interface callDispositionWrapper {
    count: number;
    data: callDisposition[];
}

const ListEditor = (props: ListEditorProps) => {

    const { list } = props;

    const [name, setName] = useState<string>(list.name)
    const [sortOrder, setSortOrder] = useState<string>(list.sortOrder)
    const [delmode, setDelmode] = useState(list.callDispositionTypeId === "0" ? "disabled" : ""); // possible values: disabled, blank, prompt, confirmed
    const [tableData, setTableData] = useState<any>({ count: 0, data: [], }) // current data (call disposition type ) for table.

    const [dropdownData, setDropdownData] = useState<any>([])
    const [refresh, doRefresh] = useReducer((d) => d + 1, 0);
    const [errors, setErrors] = useState({ name: "", })
    const [alertx, setAlertx] = useState<any>({ message: "", variant: "", showAlert: true })

    const [selectedDisposition, setDisposition] = useState<any>(0)

    const [selectValue, setSelectValue] = useState<any>(0)

    // all the dispositions, represents disconnected table
    const [dbDispositions, setDbDispositions] = useState<callDispositionWrapper>({ count: 0, data: [], })
    // all the dispositions those are linked with this call disposition type.
    const [myDispositionsFull, setMyDispositionsFull] = useState<callDispositionWrapper>({ count: 0, data: [], })

    const [clientsData, setClientsData] = useState([]);
    const [selectedClientID, setSelectedClientID] = useState<string>(list.clientID);


    // FIXME... OLX still stuck on FA V4... need to update to at least 5
    let faIconClass = "fas fa-trash"



    const close = () => {
        props.onListSaved();
    }


    const onDeleteConfirm = (resp: boolean) => {
        if (resp) {
            onListSaved(); // initiate save to delete
        }
        else {
            setDelmode("") // clear confirm popup.
        }
    }


    const onListSaved = () => {
        const apiBase = sessionStorage.getItem("apibase");
        var _url = `${apiBase}/v1/CallDispositionType`;

        let validationErrors = "";

        if (!name) {
            validationErrors = "Name of call disposition type is required. \n";
        }

        if (sortOrder==="") {
            validationErrors += `Sort Order is required. `;
        }

        if (validationErrors!=="")
        {
            setAlertx({ message: validationErrors, variant: "danger" });
            return;
        }

        const myItems = myDispositionsFull.data.filter(x => x.isNew === true || x.deleted === true);
        // ban address detail
        // form names are same as dto in this case... so just copy
        var data = {
            callDispositionTypeId: list.callDispositionTypeId,
            name: name,
            sortOrder: sortOrder,
            items: myItems,
            clientId: selectedClientID
        }

        fetch(_url,
            {
                method: list.callDispositionTypeId === "0" ? "POST" : delmode === "prompt" ? "DELETE" : "PUT",
                headers: props.getHeaders(),
                body: JSON.stringify(data)
            })
            .then(response => response.json())
            .then((resp: any) => {
                if (resp.success) {
                    if (list.callDispositionTypeId === "0") {
                        list.callDispositionTypeId = resp.newid;
                        setDelmode("");
                        // add... leave open so association can be added. 
                        props.onListSaved({
                            ...list,
                            callDispositionTypeId: resp.newid,
                            name: name,
                            sortOrder: sortOrder
                        });

                      setAlertx({ message: "New call disposition type saved successfully. Click save, or add a call disposition type.", variant: "success" });
                    }
                    else props.onListSaved(); // update... close when saved
                }
                else {
                    setAlertx({ message: resp.status, variant: "danger" });
                }
                // 
            });

    }




    const addAssociation = () => {
        const newItems: any[] = [];
        // Instead of going back to DB we can get details of CallDisposition from state variable. 
        // add the record of Disposition to table below.
        dbDispositions.data.forEach((obj: any) => {
            if (obj.callDispositionId === selectedDisposition) {
                // Deep clone of the state object
                const newRowObject = JSON.parse(JSON.stringify(obj));
                const newItem = {
                    callDispositionId: newRowObject.callDispositionId,
                    callDispositionType: newRowObject.callDispositionType,
                    clientId: newRowObject.clientId,
                    createDate: newRowObject.createDate,
                    deleted: false,
                    disposition: newRowObject.disposition,
                    extDispCode: newRowObject.extDispCode,
                    isNew: true,
                    lastModified: newRowObject.lastModified,
                    modifiedBy: newRowObject.modifiedBy,
                    priorityPosition: newRowObject.priorityPosition,
                    lastModifiedString: newRowObject.lastModified ? new Date(newRowObject.lastModified).toLocaleString() : '',
                    editbtn: <i className="fas fa-trash" style={{ color: 'red', cursor: 'pointer' }} onClick={() => removeAssociation(newRowObject.callDispositionId)} />
                };
                newItems.push(newItem);
            }
        });

        // if this new item does not already exists in memory add this 
        const exists = myDispositionsFull.data.filter(x => x.callDispositionId === selectedDisposition)[0];
        if (!exists) {
            const updatedData = [...myDispositionsFull.data, newItems[0]];
            const updatedTableData = { ...myDispositionsFull, data: updatedData };
            setMyDispositionsFull(updatedTableData);

            // make a copy
            const dropdownDataUpdated = JSON.parse(JSON.stringify(dbDispositions));
            // mark the item as Added
            dropdownDataUpdated.data.forEach(((item: any) => {
                // all the dispositions those are linked with this call disposition type.
                if (item.callDispositionId === selectedDisposition) {
                    item.isNew = true;
                }
            }));
            setDbDispositions(dropdownDataUpdated);

            doRefresh();
        } else {
            setAlertx({ message: `This type is already linked.`, variant: "danger" });
        }

        setSelectValue('');
    }


    const removeAssociation = (callDispositionId: any) => {

        // make a copy
        const myDispositionsFullUpdated = JSON.parse(JSON.stringify(myDispositionsFull));

        let markAsDeleted = false;
        // mark the item as deleted
        myDispositionsFullUpdated.data.forEach(((item: callDisposition) => {
            // all the dispositions those are linked with this call disposition type.
            if (item.callDispositionId === callDispositionId) {
                item.deleted = true;
                item.lastModified = new Date();
                markAsDeleted = item.isNew; // if item is new and also marked as delete we can remove this from memory
            }
        }));

        if (markAsDeleted) {
            const updatedTableData = { ...myDispositionsFull, data: myDispositionsFullUpdated.data.filter((x: any) => x.callDispositionId !== callDispositionId) };
            setMyDispositionsFull(updatedTableData);
        }
        else
            setMyDispositionsFull(myDispositionsFullUpdated);

        doRefresh()


        // make a copy
        const dropdownDataUpdated = JSON.parse(JSON.stringify(dbDispositions));
        // mark the item as Added
        dropdownDataUpdated.data.forEach(((item: any) => {
            // all the dispositions those are linked with this call disposition type.
            if (item.callDispositionId === callDispositionId) {
                item.isNew = false;
            }
        }));
        setDbDispositions(dropdownDataUpdated);
        doRefresh()
    }

    const columns = useMemo(
        () => [
            {
                Header: '',
                accessor: 'editbtn', // accessor is the "key" in the data
                maxWidth: 30
            },
            {
                Header: 'Disposition',
                accessor: 'disposition',
                minWidth: 250
            },
            {
                Header: 'Position',
                accessor: "priorityPosition",
                maxWidth: 80
            },
            {
                Header: 'Ext Code',
                accessor: "extDispCode",
                maxWidth: 80
            },
            {
                Header: 'Modified Date',
                accessor: "lastModifiedString",
                maxWidth: 100
            },
            {
                Header: 'Modified By',
                accessor: "modifiedBy",
                maxWidth: 100
            }
        ],
        [list, alertx]
    )

    useEffect(() => {

        fetchOptions();

        fetchClients();
        // Return a cleanup function
        return () => {
            // Cancel any outstanding asynchronous tasks here, if applicable
        };
    }, [])



    const getData = async (pageSize: number, pageIndex: number) => {

        // Load data for Dispositions Select
        //fetchOptions();
        pageIndex = pageIndex + 1;
        const startIndex = (pageIndex - 1) * pageSize;
        const endIndex = pageIndex * pageSize;

        const visibleDispositions = JSON.parse(JSON.stringify(myDispositionsFull));
        visibleDispositions.data = visibleDispositions.data
            .filter((s: any) => !s.deleted)
            .slice(startIndex, endIndex);

        visibleDispositions.data.map((d: any) => {
            d.editbtn = <i key={d.callDispositionId} className={faIconClass} style={{ color: 'red' }} title="Remove association" onClick={() => { removeAssociation(d.callDispositionId); }} />
            d.lastModifiedString =

                <OverlayTrigger placement="right" overlay={<Tooltip id="tooltip"><strong>{d.lastModified ? new Date(d.lastModified).toLocaleTimeString() : ''}</strong>  </Tooltip>}>
                    <span>{d.lastModified ? new Date(d.lastModified).toLocaleDateString() : ''}</span>
                </OverlayTrigger>
        });
        setTableData(visibleDispositions);


        const dbDispositionsUpdated = JSON.parse(JSON.stringify(dbDispositions));;
        const callDispositionOptionsX = dbDispositionsUpdated.data.map((d: any) => ({
            "value": d.callDispositionId,
            "label": d.disposition,
            isNew: myDispositionsFull.data.filter((x: any) => x.callDispositionId === d.callDispositionId && !x.deleted)[0],
            clientId: d.clientId
        }))
        if (selectedClientID==="0")
            setDropdownData(callDispositionOptionsX.filter((x: any) => !x.isNew));
        else
            setDropdownData(callDispositionOptionsX.filter((x: any) => !x.isNew && x.clientId === null || x.clientId === 0 || x.clientId === parseInt(selectedClientID)));


    }


    const fetchOptions = (() => {
        const apiBase = sessionStorage.getItem("apibase");
        var _url = `${apiBase}/v1/CallDisposition?page=${0}&pageSize=${100000}`;

        fetch(_url,
            {
                method: "GET",
                headers: props.getHeaders(),
            })
            .then(response => response.json())
            .then((resp: any) => {
                const data = resp.data;
                //const callDispositionOptions = data.map((d: any) => ({
                //    "value": d.callDispositionId,
                //    "label": d.disposition
                //}))
                //// this is specific for select (call dispositions)
                //setDropdownData(callDispositionOptions);

                const data2 = resp.data;

                data2.forEach(((item: callDisposition) => {
                    // dbDispositions variable will hold all the dispositions either are linked or not 
                    // this is helpful when Add (association is called)
                    const exists = dbDispositions.data.filter(x => x.callDispositionId === item.callDispositionId)[0];
                    if (!exists) {
                        dbDispositions.data.push(item);
                    }
                }));

                // Format and set the data in state, I need to pass type as well to filter linked only
                const formattedData = formatData(resp.data, list.callDispositionTypeId); // Call your formatting function
                const myDispositionsFullUpdated = JSON.parse(JSON.stringify(formattedData));
                setMyDispositionsFull(myDispositionsFullUpdated);

                const myDispositionsFullUpdated2 = JSON.parse(JSON.stringify(formattedData));
                myDispositionsFullUpdated2.data = myDispositionsFullUpdated.data.slice(0, 10);

                myDispositionsFullUpdated2.data.map((d: any) => {
                    //    d.editbtn = <i key={d.callDispositionId} className={faIconClass} style={{ color: 'red' }} title="Remove association" onClick={() => { removeAssociation(d.callDispositionId); }} />
                    d.lastModified = d.lastModified ? new Date(d.lastModified).toLocaleString() : '';
                });


                doRefresh()

            });
    });

    const fetchClients = (() => {
        const apiBase = sessionStorage.getItem("apibase");
        var _url = `${apiBase}/v1/Clients?page=${0}&pageSize=${100000}`;

        fetch(_url,
            {
                method: "GET",
                headers: props.getHeaders(),
            })
            .then(response => response.json())
            .then((resp: any) => {
                setClientsData(resp.data)
            });
    });


    function formatData(rawData: any, typeId: number) {
        // Perform data formatting operations here
        let formattedData: callDispositionWrapper = { data: [], count: 0 }
        formattedData.count = rawData.filter((d: any) => d.callDispositionType === typeId).length;
        formattedData.data = rawData.filter((d: any) => d.callDispositionType === typeId);
        return formattedData;
    }

    // Event handler for selecting an option
    const handleClientChange = (e: any) => {
        setSelectedClientID(e.target.value);

        const dbDispositionsUpdated = JSON.parse(JSON.stringify(dbDispositions));;
        const callDispositionOptionsX = dbDispositionsUpdated.data.map((d: any) => ({
            "value": d.callDispositionId,
            "label": d.disposition,
            isNew: myDispositionsFull.data.filter((x: any) => x.callDispositionId === d.callDispositionId && !x.deleted)[0],
            clientId: d.clientId
        }))

        if (e.target.value !== "0") {
            setDropdownData(callDispositionOptionsX.filter((x: any) => !x.isNew && x.clientId === null || x.clientId === 0 || x.clientId === parseInt(e.target.value)));
        } else {
            setDropdownData(callDispositionOptionsX.filter((x: any) => !x.isNew));
        }
    };

    const handleChange = (selectedOption: any) => {
        setSelectValue(selectedOption);
        setDisposition(selectedOption.value);
    };

    return (
        <>
            <Modal show={true} onHide={close} size="lg" >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {/*     <img src={require('/dotnetoms/Images/menu/headset.png')} />*/}
                        Call Disposition Type</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row>
                            <Form.Group as={Row} className="mb-4" controlId="formHorizontalEmail">
                                <Form.Label column sm={1}>
                                    Name
                                </Form.Label>
                                <Col sm={6}>
                                    <Form.Control placeholder="Name" value={name} required
                                        onChange={(e: any) => setName(e.target.value)} />
                                </Col>
                                <Form.Label column sm={2}>
                                    Sort Order
                                </Form.Label>
                                <Col sm={2}>

                                    <Form.Control placeholder="Sort Order" value={sortOrder} required
                                        onChange={(e: any) => setSortOrder(e.target.value)} />

                                </Col>
                            </Form.Group>
                        </Row>
                        <Row>
                            <Form.Group as={Row} className="mb-4" controlId="formHorizontalEmail">
                                <Form.Label column sm={1}>
                                    Client
                                </Form.Label>
                                <Col sm={6}>
                                    <Form.Select value={selectedClientID} disabled={JSON.parse(JSON.stringify(myDispositionsFull)).data.filter((s: any) => !s.deleted).length > 0}
                                        onChange={handleClientChange}  >
                                        <option value="0">None</option>
                                        {clientsData.map((i: any) => (
                                            <option key={i.clientId} value={i.clientId}>
                                                {i.client}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Col>
                                <Col sm={4}>
                                </Col>
                            </Form.Group>
                        </Row>
                        {(errors.name) ? <span className="valerror" >{errors.name}</span> : null}
                        <br />
                    </Container>
                    <Row>
                        <Form.Group as={Row} className="mb-4" controlId="formHorizontalEmail">
                            <Col sm={6}>
                                <Select   options={dropdownData} value={selectValue} onChange={handleChange} placeholder={"Select Call Disposition"} onFocus={() => setAlertx({ showAlert: true })} />
                            </Col>
                            <Col sm={2}>
                                <Button className="ms-1 float-start" variant="primary" onClick={addAssociation} >
                                    <i className="rbPrimaryIcon-custom" style={{ backgroundImage: `url("images/16/add2.png")`, "marginRight": "5px" }} ></i>
                                    Add</Button>
                            </Col>
                        </Form.Group>
                    </Row>
                    <PagerTable getData={getData} columns={columns} tableData={tableData} refresh={refresh} />


                    {/* Show Delete confirm if called */}
                    {delmode !== "prompt" ? null :
                        <Confirm onResponse={onDeleteConfirm} onClose={() => setDelmode("")}
                            headerText="Delete"
                            bodyText="Are you sure you want to delete this?"
                        />
                    }

                </Modal.Body>
                <Modal.Footer>
                    {alertx.message ? <div className="w-100"><Alert variant={alertx.variant} show={alertx.showAlert} onClose={() => setAlertx({ showAlert: true })} dismissible >{alertx.message}</Alert></div> : null}
                    <div className="w-100">
                        <Button onClick={onListSaved} variant="primary" className="ms-1" >
                            <i className="rbPrimaryIcon-custom" style={{ backgroundImage: `url("images/16/disk_blue.png")`, "marginRight": "5px" }} ></i>
                            Save
                        </Button>
                        <Button variant="secondary" className="ms-1" onClick={close}>
                            <i className="rbPrimaryIcon-custom" style={{ backgroundImage: `url("images/16/undo.png")`, "marginRight": "5px" }} ></i>

                            Cancel</Button>
                        {delmode !== "disabled" ? <Button variant="danger" className="float-end" onClick={() => setDelmode("prompt")}>
                            <i className="rbPrimaryIcon-custom" style={{ backgroundImage: `url("images/16/delete.png")`, "marginRight": "5px" }} ></i>

                            Delete</Button> : null}
                    </div>

                    <div className="w-100" style={{ fontSize: 12 }} >
                        <p>Created: {list.createdDttm ? new Date(list.createdDttm).toLocaleString() : ''} {list.createdBy ? 'by' : ''}  {list.createdBy}  <br />
                            Modified: {list.modifiedDttm ? new Date(list.modifiedDttm).toLocaleString() : ''} {list.modifiedBy ? 'by' : ''} {list.modifiedBy}</p>
                    </div>
                </Modal.Footer>
            </Modal>
        </>)
}

export default ListEditor;


